import React, {useEffect, useState}  from 'react';
import Slider from "react-slick";
import axios from 'axios';
// Components//
import TitleSection from "../../molecules/title-section";
import CoursesCard from '../../molecules/courses-card/coursesCard';
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import "slick-carousel/slick/slick.css";
import "./CarruselOfertasAprendizaje.scss";
import { navigate } from 'gatsby';

// Services //
import { getToken } from '../../../services/getToken';

const CarruselOfertasAprendizaje = (props: ReferenciaContenido) => {

    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);
    const [recommendedData, setRecommendedData] = useState<any[]>([]);

    const offerUrl = process.env.AGW_EMPLEO_SERVICES_API_URL + "comfama/formaciones-api/api/v1/";
    const apikeyServices = process.env.AGW_EMPLEO_SERVICES_API_KEY;
    const getLearningInformation = async () => {
            const token = await getToken();
            const headers = {
                Authorization: token.data.data.id_token,
                apikey: apikeyServices
            };
        axios.post(`${offerUrl}formaciones/filtered`,
            {
                "pageNumber":1,
                "region":"",
                "lugar":"",
                "duracionFormacion": [],
                "modalidad": [],
                "rolFormativo":[],
                "tipoFormacion": [],
                "palabraClave": ""
            },{
                headers
            }).then(function (response) {
                setRecommendedData(response?.data?.content);
            })
            .catch(function (error) {
                console.log(error);
            }
        );
    }

    useEffect(() => {
        getLearningInformation();
    }, [])

    const CarouselGeneral = {
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: false,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        beforeChange: (_: number, next: number) => {
            if(next>=0){
                setSliderIndex(next);
            }
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                    fade: false
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    fade: true
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < slider.props.children.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children.length - 1;

    const cardCTA = (item) => {
        navigate("detalle/");
        localStorage.setItem("curso", JSON.stringify(item));
    };

    return (
        <>
            <div className="o-carrusel-ofertaAprendizaje" id={"carruselofertaAprendizaje"}>
                <div className="o-carrusel-ofertaAprendizaje-title">
                    <TitleSection 
                        title={props.tituloGeneral}
                    />
                </div>
                <div className="o-carrusel-ofertaAprendizaje__container">
                    <div className="arrows-slider">
                        <span
                            className={`arrow icon-chevron-left ${isActiveBack() ? "active" : ""
                                }`}
                            onClick={goToBack}
                        ></span>
                        <span
                            className={`arrow  icon-chevron-right  ${isActiveNext() ? "active" : ""
                                }`}
                            onClick={goToNext}
                        ></span>
                    </div>
                    <div className="slider-container">
                        <Slider
                            ref={(c) => {
                                setSlider(c);
                            }}
                            {...CarouselGeneral}
                        >
                            {recommendedData?.map((card, index)=>{
                                if(index < 3){
                                    return (
                                        <CoursesCard
                                            tittle={card.portafolio}
                                            description={card.objetivo}
                                            location={card?.lugar ? card?.lugar : "Todas"}
                                            duration={card.duracion}
                                            modality={card?.modalidad ? card?.modalidad : "Virtual"}
                                            categoriaMultimedia={card.tipo_formacion}
                                            callToAction={() => cardCTA(card)}
                                            image={card.foto_desktop.includes(" ^ ") ? card.foto_desktop.split(" ^ ")[0] : card.foto_desktop}
                                            mobileImage={card.foto_mobile.includes(" ^ ") ? card.foto_mobile.split(" ^ ")[0] : card.foto_mobile}
                                        />
                                    );
                                }
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CarruselOfertasAprendizaje